module.exports = __webpack_public_path__ + "static/media/home-stock-02.3f57ab2a.png";